"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DependencyService", {
    enumerable: true,
    get: function() {
        return DependencyService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _DependencyTracker = /*#__PURE__*/ _interop_require_default(require("~/models/DependencyTracker"));
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _utils = require("~/utils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let DependencyService = class DependencyService {
    async checkDependency(context, params) {
        const { entityType, entityId } = params;
        const sourceType = entityType;
        if (!sourceType) {
            _catchError.NcError.get(context).badRequest(`Invalid entity type: ${entityType}`);
        }
        const breakingChanges = await _DependencyTracker.default.checkBreakingChanges(context, {
            sourceType: sourceType,
            sourceId: entityId
        });
        const dashboardIds = new Set();
        const workflowIds = new Set();
        for (const dep of breakingChanges.dependents){
            if (dep.dependent_type === _nocodbsdk.DependencyTableType.Widget) {
                const widget = await _models.Widget.get(context, dep.dependent_id);
                if (widget == null ? void 0 : widget.fk_dashboard_id) {
                    dashboardIds.add(widget.fk_dashboard_id);
                }
            } else if (dep.dependent_type === _nocodbsdk.DependencyTableType.Workflow) {
                workflowIds.add(dep.dependent_id);
            }
        }
        const [dashboards, workflows] = await Promise.all([
            (0, _utils.processConcurrently)(Array.from(dashboardIds), (id)=>_models.Dashboard.get(context, id)),
            (0, _utils.processConcurrently)(Array.from(workflowIds), (id)=>_models.Workflow.get(context, id))
        ]);
        const entities = [];
        for (const dashboard of dashboards.filter(Boolean)){
            entities.push({
                type: _nocodbsdk.DependencyTableType.Widget,
                entity: dashboard
            });
        }
        for (const workflow of workflows.filter(Boolean)){
            entities.push({
                type: _nocodbsdk.DependencyTableType.Workflow,
                entity: workflow
            });
        }
        return {
            hasBreakingChanges: breakingChanges.hasBreakingChanges,
            entities
        };
    }
};
DependencyService = _ts_decorate([
    (0, _common.Injectable)()
], DependencyService);
